import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { globalFileIcon } from "../../../axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import {
  setToggleMenu,
  setToggleCart,
  setToggleSidebar,
} from "../../server/CartsOpen";
import Navigator from "./NAVIGATOR";
import HeaderConnection from "./HeaderConnection";
import HeaderSearch from "./HeaderSearch";
import HeaderFilterAndSort from "./HeaderFilterAndSort";
import HeaderCart from "./HeaderCart";
import { ShoppingCart } from 'lucide-react';
import ProductFilters from "../routs/categoryPage/ProductFilters"
import MiniCart from '../../components/miniCart/MiniCart';
import Nav from '../nav-role/Nav';
import { setFilterSort } from "../../server/Product";



const Header = ({ setAllProduct, setAdminToCustomer, currentSubCategory, setProductPopUp, setSelectedProd }) => {
  const dispatch = useDispatch();
  const {
    user,
    role,
    stationId,
    productsInCart,
    toggleMenu,
    toggleSidebar,
    deliveryPrice,
    filterAndSort,
  } = useSelector((state) => ({
    user: state.user.user,
    role: state.user.role,
    stationId: state.user.stationId,
    productsInCart: state.productsInCart.productsInCart,
    toggleMenu: state.openCart.toggleMenu,
    toggleSidebar: state.openCart.toggleSidebar,
    deliveryPrice: state.productsInCart.deliveryPrice,
    filterAndSort: state.displayProduct.filterAndSort,
  }));
  const { pathname } = useLocation();
  const [cartIsOpen, setCartIsOpen] = useState(false)
  const headerWrapperRef = useRef(null);
  const headerSecondRowRef = useRef(null);
  const cartFiltersRef = useRef(null);
 
  const setHeaderSecondRowPosition = () => {
    const headerWrapper = headerWrapperRef.current;
    const headerSecondRow = headerSecondRowRef.current;
    const cartFilters = cartFiltersRef.current;

    if (headerWrapper && headerSecondRow) {
      const headerWrapperHeight = headerWrapper.offsetHeight;
      headerSecondRow.style.top = headerWrapperHeight + 'px';
      if (cartFilters)
        cartFilters.style.top = (parseInt(headerWrapperHeight) + 45).toString() + 'px';
    }
  };

  useEffect(() => {
    if (!role && user) {
      dispatch(setToggleCart(true));
    }
  }, [role, user, dispatch]);

  useEffect(() => {
    const headerWrapper = headerWrapperRef.current;
    
    if (!headerWrapper) {
      return;
    }

    setHeaderSecondRowPosition();
    
    const observer = new ResizeObserver(() => {
      setHeaderSecondRowPosition();
    });

    observer.observe(headerWrapper);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    setHeaderSecondRowPosition();
  }, [pathname, cartIsOpen, filterAndSort]);


  const setCart = (setOpen) => {
    if (filterAndSort) {
      dispatch(setFilterSort(false));
      dispatch(setToggleCart(true))
      setCartIsOpen(true);
    }
    else {
      dispatch(setToggleCart(setOpen))
      setCartIsOpen(setOpen);
    }
  }

  const setNav = () => {
    if (filterAndSort) {
      dispatch(setToggleSidebar(true));
      dispatch(setFilterSort(false));
      setCartIsOpen(false);
    } else {
      dispatch(setToggleSidebar(!toggleSidebar));
      setCartIsOpen(false);
    }
  }

  return (
    <header>
      <div className="header-wrapper" ref={headerWrapperRef}>
        <HeaderConnection
          setAllProduct={setAllProduct}
          setAdminToCustomer={setAdminToCustomer}
          user={user}
          role={role}
          stationId={stationId}
        />
        {pathname !== "/about" ? (
          <>
            <div className="head-right-side">
              <div className="menu" onClick={() => dispatch(setToggleMenu())}>
                {toggleMenu ? (
                  <img src={globalFileIcon + "close-menu.svg"} alt="close" />
                ) : (
                  <img src={globalFileIcon + "menu-new.svg"} alt="menu" />
                )}
              </div>
              <Navigator currentSubCategory={currentSubCategory} />
            </div>
            <div className="header-first-row">
              {!role && <HeaderCart
                role={role}
                user={user}
                pathname={pathname}
                productsInCart={productsInCart}
                deliveryPrice={deliveryPrice}
              />}
              <HeaderSearch />
            </div>
            
          </>
        ) : null}
      </div>
      <div className="header-second-row" ref={headerSecondRowRef}>
      {role ? (
          <div
            onClick={() => setNav()}
            className="toggle-nav"
          >
            {toggleSidebar ? (
              <img src={globalFileIcon + "close.svg"} alt="menu" />
            ) : (
              <img src={globalFileIcon + "menu_new.svg"} alt="menu" />
            )}
          </div>
        ) : 
        <div className="shoping-cart" onClick={() => setCart(!cartIsOpen)}><ShoppingCart/><span>לעגלת הקניות</span></div>}
        {pathname.includes("/category/") && <><div className="cross-line">|</div>
         <HeaderFilterAndSort /></>}
        {(cartIsOpen || pathname.includes("/category/") || pathname.includes("/search") || toggleSidebar) && <div className='side' ref={cartFiltersRef}>
          {filterAndSort && (pathname.includes("/category/") || pathname.includes("/search")) && <ProductFilters />}
          { cartIsOpen ? <MiniCart setProductPopUp={setProductPopUp} setSelectedProd={setSelectedProd}/> : role ? <Nav /> : null}
        </div>}
      </div>
    </header>
  );
};

export default Header;